package com.partejar.app.feature.gestantes.presentation

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.*
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.semantics.*
import com.partejar.app.core.ui.components.PartejarCard
import com.partejar.app.core.ui.components.PartejarMotion
import com.partejar.app.core.ui.components.PartejarSkeleton
import com.partejar.app.core.ui.components.PartejarSkeletonText
import com.partejar.app.core.ui.components.reducedMotion
import com.partejar.app.core.ui.theme.PartejarTheme

/** Single content group enters after loading: low motion density, no per-row cascade on scroll. */
@Composable
internal fun ExamEntrance(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    val reduced = reducedMotion()
    val progress = remember { Animatable(if (reduced) 1f else 0f) }
    LaunchedEffect(reduced) {
        if (reduced) progress.snapTo(1f)
        else progress.animateTo(1f, tween(PartejarMotion.entrance, easing = PartejarMotion.enter))
    }
    Box(modifier.graphicsLayer {
        alpha = progress.value
        scaleX = if (reduced) 1f else 0.98f + 0.02f * progress.value
        scaleY = scaleX
    }) { content() }
}

@Composable
internal fun ExamFeedbackVisibility(visible: Boolean, content: @Composable () -> Unit) {
    val reduced = reducedMotion()
    AnimatedVisibility(
        visible = visible,
        enter = fadeIn(tween(PartejarMotion.feedback)) + scaleIn(tween(PartejarMotion.feedback, easing = PartejarMotion.enter), initialScale = if (reduced) 1f else 0.98f),
        exit = fadeOut(tween(PartejarMotion.release)) + scaleOut(tween(PartejarMotion.release, easing = PartejarMotion.exit), targetScale = if (reduced) 1f else 0.98f)
    ) { content() }
}

@Composable
internal fun ExamLoading(modifier: Modifier = Modifier) {
    val spacing = PartejarTheme.spacing
    Column(modifier.padding(spacing.space16).semantics {
        stateDescription = "Carregando exames"
        liveRegion = LiveRegionMode.Polite
    }, verticalArrangement = Arrangement.spacedBy(spacing.space16)) {
        repeat(3) {
            PartejarCard(Modifier.fillMaxWidth().clearAndSetSemantics { }) {
                Column(verticalArrangement = Arrangement.spacedBy(spacing.space12)) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(spacing.space12)
                    ) {
                        PartejarSkeletonText(Modifier.weight(1f).height(spacing.space20))
                        PartejarSkeletonText(Modifier.fillMaxWidth(0.28f).height(spacing.space20))
                    }
                    PartejarSkeletonText(Modifier.fillMaxWidth(0.4f).height(spacing.space12))
                    PartejarSkeletonText(Modifier.fillMaxWidth(0.8f).height(spacing.space12))
                }
            }
        }
    }
}
